import hljs from "highlight.js/lib/core";
import supportedLanguages from "./supportedLanguages";

supportedLanguages.forEach((language) => hljs.registerLanguage(language.name, language.definition));

const transformRows = (block, disableRowNumbers) => {
    let resultHTML = "";
    let lines = block.innerHTML.split("<br>");
    if (lines.length === 0) return;

    for (const [index, line] of lines.entries()) {
        if (index === lines.length - 1 && line.replace(/(<([^>]+)>)/gi, "").trim() === "") continue;

        resultHTML += "\n";

        if (!disableRowNumbers) resultHTML += `<span class="hljs__line-number">${index + 1}</span>`;

        resultHTML += line.trim();
    }

    block.innerHTML = resultHTML;
};

const handleCopyButtonClick = (text) => {
    const txt = text.replaceAll(String.fromCharCode(160), " ").replace(/^[0-9]+/gm, "");
    navigator.clipboard.writeText(txt);
};

// Get rid of the flicker when loading
const showElement = (el) => el.classList.remove("code--hidden");

export default function(el) {
    const block = el.querySelector("code");
    const copyButton = el.querySelector(".code__copy");

    if (!block) return;

    hljs.highlightElement(block);

    if(window.location.href.includes("academy")) {
        const child = el.querySelector(".code");
        const toggleRows = JSON.parse(child.dataset.disableRowNumbers)
        showElement(child);
        transformRows(block, toggleRows);
    } else {
        showElement(el);
        transformRows(block, el.dataset.disableRowNumbers);
    }

    if (copyButton) copyButton.addEventListener("click", handleCopyButtonClick.bind(null, block.innerText));
}
